import React from 'react';
import NiceWrapper from 'components/NiceWrapper';
import { Redirect } from 'react-router-dom';

function BetaPage(props) {
    // If user is granted access, redirec them
    if (props.auth.user.allow_access == 1) {
        return <Redirect to="/studies" />;
    }
    return (
        <div style={{ margin: '32px auto', textAlign: 'center' }}>
            <NiceWrapper style={{ background: 'white', color: 'black', padding: '32px' }}>
                <strong>Thank you for registering. We will reach out asap to enable access.</strong>
                <br />
                <br />
                If you have any questions please email{' '}
                <a href="mailto:support@panelfox.io?subject=Beta access">support@panelfox.io</a>.
            </NiceWrapper>
        </div>
    );
}

export default BetaPage;
